
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M19.793 7.22a11.006 11.006 0 00-4.376-4.26L17.844.511a.305.305 0 000-.425.298.298 0 00-.422 0L8.44 9.15a1.962 1.962 0 01-.37-1.147c0-1.072.867-1.946 1.93-1.946.187 0 .373.028.552.08a.296.296 0 00.37-.204.3.3 0 00-.199-.373 2.584 2.584 0 00-.72-.105c-1.392 0-2.526 1.144-2.526 2.548 0 .577.191 1.127.541 1.576l-.938.939a3.864 3.864 0 01-.923-2.515c0-2.135 1.722-3.871 3.839-3.871.624 0 1.22.148 1.77.437a.3.3 0 00.274-.534 4.433 4.433 0 00-2.044-.505c-2.447 0-4.436 2.006-4.436 4.473 0 1.09.386 2.125 1.094 2.944l-1.639 1.652A10.448 10.448 0 01.723 8.483a.987.987 0 010-.963C2.581 4.243 6.137 2.205 10 2.205c1.165 0 2.31.18 3.405.542a.301.301 0 00.187-.574A11.434 11.434 0 009.999 1.6C5.922 1.6 2.171 3.754.207 7.22a1.581 1.581 0 000 1.56 11.007 11.007 0 004.376 4.26l-2.427 2.448a.304.304 0 000 .425.294.294 0 00.422 0l8.986-9.062c.239.333.37.73.37 1.147a1.942 1.942 0 01-1.93 1.946c-.186 0-.373-.028-.552-.08a.297.297 0 00-.37.2.3.3 0 00.198.373c.235.073.478.105.725.105 1.392 0 2.526-1.144 2.526-2.548 0-.577-.191-1.127-.541-1.576l.93-.939c.597.702.923 1.585.923 2.515 0 2.134-1.722 3.871-3.838 3.871a3.768 3.768 0 01-1.77-.437.3.3 0 00-.274.534 4.432 4.432 0 002.044.505c2.446 0 4.435-2.006 4.435-4.473a4.476 4.476 0 00-1.094-2.944l1.639-1.652a10.46 10.46 0 014.3 4.111.988.988 0 010 .963c-1.858 3.277-5.414 5.315-9.276 5.315-1.254 0-2.483-.209-3.648-.626a.3.3 0 00-.382.184.303.303 0 00.183.386c1.229.437 2.526.657 3.847.657 4.077 0 7.828-2.154 9.793-5.62a1.579 1.579 0 00-.008-1.548z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./public/dist/img/svg/EyeClosed.svg